export const ADD_SUBACCOUNT = 'ADD_SUBACCOUNT'
export const CHOOSE_DATE = 'CHOOSE_DATE'
export const LOGOUT_DIALOG = 'LOGOUT_DIALOG'
export const CREATE_SUBACCOUNT = 'CREATE_SUBACCOUNT'
export const ADD_FINANCIAL_KEY = 'ADD_FINANCIAL_KEY'
export const EDIT_WALLET = 'EDIT_WALLET'
export const EDIT_EMAIL = 'EDIT_EMAIL'
export const CONFIRM_EDIT_EMAIL = 'CONFIRM_EDIT_EMAIL'
export const POOL_SETTINGS = 'POOL_SETTINGS'
export const REFUSE_REASON = 'REFUSE_REASON'
export const EDIT_DOCUMENTS = 'EDIT_DOCUMENTS'
